<script>
import { Line } from 'vue-chartjs/legacy'
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement,
  Filler,
} from 'chart.js'

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement,
  Filler,
)

export default {
  name: 'Chart',
  extends: Line,
  props: {
    chartOptions: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
    }
  },
  mounted() {
    this.renderChart(this.chartData, {
      responsive: true,
      maintainAspectRatio: true,
    })
  },
  methods: {
  },
}

</script>
